import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {BDCPConstsService, BDCPFilterService, BDCPShareService} from 'brother-dealerapp-component-products-lib';

@Component({
    selector: 'bdcp-products-search-bar',

    templateUrl: './products-search-bar.component.html',
    styleUrl: './products-search-bar.component.scss'
})
export class BDCPProductsSearchBarComponent {

    constructor(private router: Router,
                public share: BDCPShareService,
                public consts: BDCPConstsService,
                public filterService: BDCPFilterService) {
    }


    public async navigateToBookmarks() {
        await this.router.navigate(['/products', 'bookmarks']);
    }

}
